module.exports = __webpack_public_path__ + "img/bill2.1ba7c6a0.png";